import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var BuyNowSvg = /*#__PURE__*/_jsx("svg", {
  className: "lg:mr-2 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.435",
  height: "13.153",
  viewBox: "0 0 15.435 13.153",
  children: /*#__PURE__*/_jsx("path", {
    id: "shopping-cart",
    d: "M7.626,14.576a.994.994,0,1,1-.994.994A.994.994,0,0,1,7.626,14.576Zm4.323,0a.994.994,0,1,1-.994.994A.994.994,0,0,1,11.949,14.576ZM1.026,4.647h1.4a.609.609,0,0,1,.587.446h0l1.97,7.091a1.855,1.855,0,0,0,1.787,1.359h6a1.855,1.855,0,0,0,1.8-1.406c.418-1.671,1.249-4.993,1.249-4.993a.618.618,0,0,0-.6-.768H6.632a.618.618,0,0,0,0,1.236h7.8l-1.057,4.227a.619.619,0,0,1-.6.469h-6a.62.62,0,0,1-.6-.454h0L4.207,4.762A1.844,1.844,0,0,0,2.43,3.411h-1.4a.618.618,0,1,0,0,1.236Z",
    transform: "translate(-0.408 -3.411)",
    fill: "#fff",
    "fill-rule": "evenodd"
  })
});
export var TickSvg = /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: [/*#__PURE__*/_jsxs("g", {
    id: "Ellipse_1864",
    "data-name": "Ellipse 1864",
    fill: "#4652a4",
    stroke: "#fff",
    "stroke-width": "5",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "40",
      cy: "40",
      r: "40",
      stroke: "none"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "40",
      cy: "40",
      r: "37.5",
      fill: "none"
    })]
  }), /*#__PURE__*/_jsx("g", {
    transform: "translate(25 29)",
    children: /*#__PURE__*/_jsx("path", {
      id: "check",
      d: "M33.654,7.527a2.022,2.022,0,0,0-2.928,0L15.039,23.214,8.556,16.73a2.07,2.07,0,1,0-2.928,2.928l7.948,7.948a2.022,2.022,0,0,0,2.928,0l17.15-17.15A2.022,2.022,0,0,0,33.654,7.527Z",
      transform: "translate(-5 -6.9)",
      fill: "#fff"
    })
  })]
});
export var AlertSvg = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  className: "w-full h-full p-0 m-0",
  viewBox: "0 0 81.452 95.027",
  children: /*#__PURE__*/_jsxs("g", {
    id: "_299112_warning_shield_icon",
    "data-name": "299112_warning_shield_icon",
    transform: "translate(-3 -1030.4)",
    children: [/*#__PURE__*/_jsx("path", {
      id: "Path_171",
      "data-name": "Path 171",
      d: "M3,1031.4v45.251c0,19,16.436,36.2,40.726,45.251,24.291-9.05,40.726-26.246,40.726-45.251V1031.4Z",
      transform: "translate(0 3.525)",
      fill: "#95a5a6"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_172",
      "data-name": "Path 172",
      d: "M3,1030.4v45.25c0,19.005,16.436,36.2,40.726,45.251,24.291-9.05,40.726-26.246,40.726-45.251V1030.4Z",
      transform: "translate(0 0)",
      fill: "#ecf0f1"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_173",
      "data-name": "Path 173",
      d: "M3,1030.4v45.25c0,19.005,16.436,36.2,40.726,45.251v-90.5Z",
      transform: "translate(0 0)",
      fill: "#bdc3c7"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_174",
      "data-name": "Path 174",
      d: "M5,1032.4v36.2c0,15.386,12.784,28.961,31.676,36.2,18.892-7.24,31.676-20.815,31.676-36.2v-36.2Z",
      transform: "translate(7.05 7.051)",
      fill: "#f39c12"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_175",
      "data-name": "Path 175",
      d: "M12,1032.4v72.4c18.892-7.24,31.676-20.815,31.676-36.2v-36.2Z",
      transform: "translate(31.726 7.051)",
      fill: "#f1c40f"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_176",
      "data-name": "Path 176",
      d: "M15.525,1034.4A4.394,4.394,0,0,0,11,1038.925l2.263,31.675h4.525l2.263-31.675A4.394,4.394,0,0,0,15.525,1034.4Zm0,40.726A4.394,4.394,0,0,0,11,1079.651a4.685,4.685,0,0,0,4.525,4.525,4.685,4.685,0,0,0,4.525-4.525A4.394,4.394,0,0,0,15.525,1075.126Z",
      transform: "translate(28.201 14.1)",
      fill: "#34495e"
    })]
  })
});